var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentCallVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 12",
    width: 20,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Layer",
    d: "M2.17 11.89c-.2 0-.39-.04-.57-.11a1.27 1.27 0 01-.47-.32c-.14-.13-.25-.29-.33-.47a1.55 1.55 0 01-.11-.56V1.64c0-.19.04-.38.11-.56C.88.9.99.74 1.12.61c.14-.14.3-.25.48-.32s.37-.11.57-.11h11.81c.19 0 .38.04.56.11.18.07.34.18.48.32.13.13.24.29.32.47.07.18.11.37.11.56v1.59l2.48-2.05c.11-.09.24-.15.38-.17.14-.01.28.01.41.07a.8.8 0 01.31.27c.07.11.11.25.11.39v8.59c0 .14-.04.27-.11.39a.8.8 0 01-.31.27c-.13.06-.27.08-.41.06a.68.68 0 01-.38-.16l-2.48-2.05v1.59c0 .19-.04.38-.11.56-.08.18-.19.34-.32.47-.14.14-.3.25-.48.32s-.37.11-.56.11H2.17z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentCallVideo);
export default __webpack_public_path__ + "static/media/recent-call-video.664d8e8d60ac7cc0c7f663430fa72934.svg";
export { ForwardRef as ReactComponent };